import { Button, type ButtonProps, GoatWithPartner, Text } from '@capsicum/common-web';
import { ExternalLinkIcon } from '@capsicum/common-web/icons';
import { type NCWSendResumeDrawerProps, useNCWSendResumeDrawer } from '@capsicum/features/nc-wallet/shared';
import styled from 'styled-components';

/**
 * This drawer shows at the end of the NCW Send flow, concludes a successful transaction
 * @param {() => void} closeModal The callback closes the modal and navigates to NCW Home Page
 * @param {string} transactionHash The transaction hash needed to show transaction details on chain explorer
 */
export const NCWSendResumeDrawer = ({ closeModal, onTransactionHistoryRedirect }: NCWSendResumeDrawerProps) => {
	const { $t, intlText, partnerLogo } = useNCWSendResumeDrawer();

	const backHomeButtonProps = {
		color: 'brand',
		onClick: closeModal,
		testID: 'ncw-send-success-backToWallet-button',
		text: intlText.backButtonText
	} satisfies ButtonProps;

	return (
		<S.Wrapper data-testid="ncw-send-success-modal">
			<GoatWithPartner
				goatType="congratulations"
				partnerLogo={partnerLogo ?? ''}
				partnerLogoDisplay
				withoutTitleContainer
			/>
			<S.TextContainer>
				<Text variant="title6">{intlText.title}</Text>
				<Text variant="text3">{intlText.description}</Text>
			</S.TextContainer>
			<Button {...backHomeButtonProps} />

			<Button
				color="neutral"
				iconEnd={{ icon: { src: ExternalLinkIcon } }}
				testID="ncw-send-success-viewTransactionDetails-link"
				text={$t('ncWallet.send.resume.viewTransactionDetailsText')}
				variant="text"
				onClick={() => onTransactionHistoryRedirect()}
			/>
		</S.Wrapper>
	);
};

namespace S {
	export const Wrapper = styled.div`
		max-width: ${({ theme }) => `${theme.breakpoints.points.tabletSmallDesktop.pageWidth}px`};
		height: 100%;
		width: 100%;
		display: flex;
		flex-direction: column;
		align-items: center;
		gap: ${({ theme }) => theme.spacings.small};
	`;

	export const TextContainer = styled.div`
		display: flex;
		flex-direction: column;
		align-items: center;
		gap: ${({ theme }) => theme.spacings.xxsmall};
	`;
}
